import { useMemo } from "react";
import {
  AmlEntityTypeQuestion,
  GetAmlQuestionsByAccountTypeQuery,
} from "../../../graphql/supergraphTypes";

/**
 * Custom hook to extract profile questions from compliance case data
 * @param data - The compliance case data from GraphQL query
 * @param profileId - The ID of the profile to find questions for
 * @returns Array of AML entity type questions for the specified profile
 */
export const useProfileQuestions = (
  data: GetAmlQuestionsByAccountTypeQuery | undefined,
  profileId?: number,
): AmlEntityTypeQuestion[] => {
  return useMemo(() => {
    if (!data?.complianceCase || !profileId) {
      return [];
    }

    const allProfiles = [
      ...(data.complianceCase.profiles || []),
      ...(data.complianceCase.investingProfile ? [data.complianceCase.investingProfile] : []),
    ];

    const targetProfile = allProfiles.find((profile) => profile?.id === profileId);
    return targetProfile?.amlEntityTypeQuestions || [];
  }, [data, profileId]);
};
